module.exports = __webpack_public_path__ + "assets/info.0c4ea63e.svg";